module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\">{{$ctrl.title}}</h3>\n</div>\n<div class=\"modal-body\">\n    <form class=\"form\">\n        <input type=\"text\" ng-model=\"$ctrl.group.name\" placeholder=\"Group Name\" class=\"form-control\" autofocus/>\n    </form>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-default\" ng-click=\"$ctrl.close()\">Cancel</button>\n    <button class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\">{{$ctrl.saveButtonText}}</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/groups/edit-group-dialog.html
// module id = 397
// module chunks = 1